import React from 'react';
import { Col, Row } from 'components/Core/Grid';
import HyperLink from 'components/Core/HyperLink';
import Link from '../Link';

import { SimpleMenuContainer } from './styles';

const SimpleMenu = ({ dropdownItems, menu }) => {
  const itemsLength = dropdownItems.length;
  const singleColList = itemsLength < 7;
  const leftColLength = singleColList
    ? itemsLength
    : itemsLength % 2 === 0
    ? itemsLength / 2
    : (itemsLength - 1) / 2 + 1;

  return (
    <SimpleMenuContainer>
      <Row>
        <Col
          xs={singleColList ? 24 : 12}
          className={`simple-nav-col ${!singleColList ? 'right' : ''}`}
        >
          {dropdownItems.map((item, index) => {
            if (index < leftColLength) {
              return <Link item={item} key={`single-col-item-${index}`} />;
            }
          })}
        </Col>
        {!singleColList && (
          <Col xs={12} className="simple-nav-col left">
            {dropdownItems.map((item, index) => {
              if (index >= leftColLength) {
                return <Link item={item} key={`two-col-item-${index}`} />;
              }
            })}
          </Col>
        )}
      </Row>
      {menu?.ctas && (
        <div className="simple-nav-ctas">
          {menu?.ctas?.map((cta, index) => {
            return (
              <HyperLink
                href={cta?.url}
                className="header-menu-cta"
                data-position="Header - Menu Item CTA"
                key={`cta-${index}`}
              >
                {cta?.buttonLabel}
              </HyperLink>
            );
          })}
        </div>
      )}
    </SimpleMenuContainer>
  );
};

export default SimpleMenu;
